$('.js-cookies-settings').on('click', function () {
    var collection = document.getElementsByClassName('cookie'),
        i = 0;

    while ( i < collection.length )
    {
        if ( collection[i].checked === true )
        {
            Cookies.set(collection[i].id, collection[i].value, { expires: 365 } );
        }
        else
        {
            Cookies.remove(collection[i].id);
        }
        i++;
    }

    Cookies.set( 'cookieconsent_status', 'allow', { expires: 365 } );
});

$('.js-cookies-decline').on('click', function () {
    Cookies.set('cookies_notification', 'seen', { expires: 365 } );
    Cookies.set('analytics_scripts', 'forbidden', { expires: 365 } );
    Cookies.set('marketing_scripts', 'forbidden', { expires: 365 } );
    $('.cookies-section').css('display', 'none');
});

$('.js-cookies-accept').on('click', function () {
    Cookies.set('cookies_notification', 'seen', { expires: 365 } );
    Cookies.set('analytics_scripts', 'allowed', { expires: 365 } );
    Cookies.set('marketing_scripts', 'allowed', { expires: 365 } );
    $('.cookies-section').css('display', 'none');
});


// WEBPACK FOOTER //
// ./js/dev/cookies.js